import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
import { MarkerClusterer } from '@googlemaps/markerclusterer';

interface ClustererContextType {
  clusterer: MarkerClusterer | null;
}

const ClustererContext = createContext<ClustererContextType>({ clusterer: null });

export const useClusterer = () => useContext(ClustererContext);

export const ClustererProvider = ({ children }: { children: ReactNode }) => {
  const map = useMap();
  const [clusterer, setClusterer] = useState<MarkerClusterer | null>(null);

  useEffect(() => {
    if (!map) return;
    
    const newClusterer = new MarkerClusterer({
      map,
      markers: [],
    });
    
    setClusterer(newClusterer);
    
    return () => {
      newClusterer.clearMarkers();
    };
  }, [map]);

  return (
    <ClustererContext.Provider value={{ clusterer }}>
      {children}
    </ClustererContext.Provider>
  );
};
